import { TextInput } from '@adc/parallax-component-library';

import type { CLMEmailInputProps } from './types';

export const CLMEmailInput = ({
  label,
  placeholder,
  ariaLabel,
  ...rest
}: CLMEmailInputProps) => {
  return (
    <TextInput
      aria-label={ariaLabel ?? 'Email Address'}
      label={label ?? 'Email address'}
      placeholder={placeholder ?? 'Email'}
      inputMode="email"
      autoCapitalize="none"
      autoCorrect={false}
      {...rest}
    />
  );
};
